module.exports = __webpack_public_path__ + "img/Blibli PayLater.03ee2c38.png";